var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var ShapeWrapperInteractionView = require("./../../shapeWrapperViewer/shapeWrapperInteractionView.js");

var SolderPasteInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    ShapeWrapperInteractionView.apply(this, arguments);
};
lib_core.inherit(SolderPasteInteractionView,  ShapeWrapperInteractionView);

module.exports = SolderPasteInteractionView;

SolderPasteInteractionView.prototype.getLayers = function () {
    if(this.data.layerIndex.contains(0) &&
        (this.editorModel.visibleLayers.contains(0) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.TOP))) {
        console.assert(this.layers.solderpasteTop && this.layers.solderpasteTopControl, "Missing layers");

        return {
            draw: this.layers.solderpasteTop,
            control: this.layers.solderpasteTopControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
    else if(this.data.layerIndex.contains(1) &&
        (this.editorModel.visibleLayers.contains(1) || this.editorModel.visibleLayers.contains(cio_datamodel.FootprintLayers.BOTTOM))){
        console.assert(this.layers.solderpasteBottom && this.layers.solderpasteBottomControl, "Missing layers");

        return {
            draw: this.layers.solderpasteBottom,
            control: this.layers.solderpasteBottomControl,
            interaction: this.layers.interaction,
            interactionControl: this.layers.interactionControl
        };
    }
}